import { AppRouter } from '@components/router';
import { URLS } from 'shared/urls';

export function finalCheckoutPageURL(course: { id: string; title: string }) {
  return URLS.student.coursePage({ course, page: 'profile-fields' });
}

export async function redirectToCourse(router: AppRouter, course: { id: string; title: string }) {
  return router.redirectTo(finalCheckoutPageURL(course));
}
